(function () {
    'use strict';

    /**
     * @ngdoc object
     * @name crewing.controller:AddMemoCtrl
     *
     * @description
     *
     */
    angular
        .module('crewing')
        .controller('AddMemoCtrl', AddMemoCtrl);

    function AddMemoCtrl($uibModalInstance, modalParams, $window, CommonMasterData, MessageService, CrewingHelper) {
        var vm = this;

        vm.model = {
            params: {
                memoId: (modalParams.memo && modalParams.memo.memoId) || null,
                version: (modalParams.memo && modalParams.memo.version),
                crewProfileId: modalParams.crewProfileId,
                memoCategory: null,
                memoDate: modalParams.day,
                message: (modalParams.memo && modalParams.memo.message) || '',
                showOnCrewScheduleFlag: (modalParams.memo && modalParams.memo.showOnCrewSchedule) || false,
                readOnly:modalParams.readOnly,
                status:modalParams.status,
                crewId:modalParams.crewId,
                batch:modalParams.batch,
                group:modalParams.group
            },
            memoCategoryTypes: []
        };

        (function INIT() {
            loadMemoCategories();
        })();

        vm.closeMe = function () {
            $uibModalInstance.close();
        };

        vm.onDeleteClick = function () {
        	if( vm.model.params.status && vm.model.params.memoId){
        		CrewingHelper.deleteMemo(vm.model.params.memoId, vm.model.params.version,
        				function () {
        			MessageService.success(MessageService.MESSAGES.CREWING.DELETE_MEMO_SUCCESS);
        			$uibModalInstance.close({crewId: modalParams.crewId});
        			vm.model.params = "";
        		},
        		function (error) {
        			MessageService.error(error);
        		});
        	}
        };

        angular.element($window).bind('keydown', function (e) {
          	 if(e.which == 46 || e.which == 110){
          		vm.onDeleteClick();
           }
          })

        vm.onSaveClick = function () {
          if(vm.model.params.status){
            vm.onSaveClickHelper();
          } else {
            if(!vm.model.params.memoId){
              vm.onSaveClickHelper();
            }
          }
        };

        vm.onSaveClickHelper = function () {
          if (vm.form.$valid) {
            CrewingHelper.saveMemo(vm.model.params,
              function () {
                MessageService.success(MessageService.MESSAGES.CREWING.ADD_MEMO_SUCCESS);
                $uibModalInstance.close({crewId: modalParams.crewId});
              },
              function (error) {
                MessageService.error(error);
              }
            );
          }
        }

        function loadMemoCategories() {
            CommonMasterData.getMemoCategories(
                function (categories) {
                    vm.model.memoCategoryTypes = categories;
                    if (modalParams.memo && modalParams.memo.memoCategoryCode) {
                        vm.model.params.memoCategory = _.find(vm.model.memoCategoryTypes, {categoryCode: modalParams.memo.memoCategoryCode});
                    }
                },
                function (error) {
                    MessageService.error(error);
                }
            );
        }

    }
}());
